module.exports = __webpack_public_path__ + "assets/images/JMDBOX5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBOX5.png
// module id = 1397
// module chunks = 1